import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("iq_lang") || "tr");
  useEffect(() => { localStorage.setItem("iq_lang", lang); }, [lang]);
  const t = (key) => translations[lang]?.[key] ?? translations.en[key] ?? key;
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
